module.exports = __webpack_public_path__ + "1a314d7f3f0d164c864c748879f4ea9b.MP3";